import { assertEvent, assign } from 'xstate5';

import { getModificationsAfterSplit } from '../../helpers';
import {
  type CustomizationMachineAction,
  type SplitPortionAction,
} from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const toggleSplitPortion: CustomizationMachineAction<Params> = assign(
  (args, params) => {
    const { context, event } = args;

    assertEvent(event, [
      'customization.toggle-split-portion',
      'customization.remove-split-portion-completely',
    ]);

    const { action } = params;

    const { ingredientId } = event;
    const { allModificationsMap, modifications, modificationLimits } = context;
    const modification = allModificationsMap?.get(ingredientId);

    // ─── Missing Data ──────────────────────────────────────────────────────────

    if (!allModificationsMap || !modifications || !modification) {
      return {};
    }

    // ───────────────────────────────────────────────────────────────────────────

    const { modificationGroupName } = modification;
    const { active } = modifications;

    const updatedActive = getModificationsAfterSplit({
      activeModifications: active,
      ingredientId,
      modificationGroupName,
      modificationLimits,
      allModificationsMap,
      action,
    });

    return {
      modifications: { ...modifications, active: updatedActive },
    };
  },
);

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  action: SplitPortionAction;
};
